import { type InjectionKey } from "vue";

import { type FormWrapperProvide } from "shared/components/base/BaseFormWrapper";
import { type TabsProvide } from "shared/components/base/BaseTabs/BaseTabs.vue";

export const FormWrapperSymbol = Symbol(
  "BaseFormWrapper"
) as InjectionKey<FormWrapperProvide>;

export const ProgressStepCurrentSymbol = Symbol(
  "ProgressStepCurrent"
) as InjectionKey<() => number>;

export const ProgressStepSelectSymbol = Symbol(
  "ProgressStepSelect"
) as InjectionKey<(step: { step: number }) => void>;

export const SimpleBooleanOverrideTooltipSymbol = Symbol(
  "SimpleBooleanOverrideTooltip"
) as InjectionKey<boolean>;

export const TabsSymbol = Symbol("Tabs") as InjectionKey<TabsProvide>;
